// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsPropertyDetailsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, PropertyDetailsResponseDto, UpdateApplicationsAcceptedRequestDto } from '../..';

interface DetailsParams {
  listingAlias: ListingAlias;
}
interface IsListingPresentParams {
  listingAlias: ListingAlias;
}

export const CappsPropertyDetailsWebApiHandler_details_Path = '/api/web/landlord/v1/properties/details';

export const CappsPropertyDetailsWebApiHandler_details = (getParams: DetailsParams, client = getClient()) => {
  return httpFrontEndRequest<DetailsParams, never, PropertyDetailsResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsPropertyDetailsWebApiHandler_details_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsPropertyDetailsWebApiHandler_isListingPresent_Path =
  '/api/web/landlord/v1/properties/isListingPresent';

export const CappsPropertyDetailsWebApiHandler_isListingPresent = (
  getParams: IsListingPresentParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<IsListingPresentParams, never, boolean>(
    {
      getParams: getParams,
      endpoint: CappsPropertyDetailsWebApiHandler_isListingPresent_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsPropertyDetailsWebApiHandler_updateApplicationsAccepted_Path =
  '/api/web/landlord/v1/properties/updateApplicationsAccepted';

export const CappsPropertyDetailsWebApiHandler_updateApplicationsAccepted = (
  postData: UpdateApplicationsAcceptedRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UpdateApplicationsAcceptedRequestDto, void>(
    {
      endpoint: CappsPropertyDetailsWebApiHandler_updateApplicationsAccepted_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};
